export default __webpack_public_path__ + "static/media/icon-prev.f5268800.svg";